<template>
    <div class="auth-wrapper auth-v2">
        <b-row class="auth-inner m-0">

            <!-- Brand logo-->
            <b-link class="brand-logo">
                <b-img :src="logoUrl"/>
            </b-link>
            <!-- /Brand logo-->

            <!-- Left Text-->
            <b-col
                    lg="8"
                    class="d-none d-lg-flex align-items-center p-5"
            >
                <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                    <b-img
                            fluid
                            :src="imgUrl"
                            alt="Login V2"
                    />
                </div>
            </b-col>
            <!-- /Left Text-->

            <!-- Login-->
            <b-col
                    lg="4"
                    class="d-flex align-items-center auth-bg px-2 p-lg-5"
            >
                <b-col
                        sm="8"
                        md="6"
                        lg="12"
                        class="px-xl-2 mx-auto"
                >
                    <b-card-title
                            title-tag="h2"
                            class="font-weight-bold mb-2"
                    >
                        Bejelentkezés
                    </b-card-title>
                    <b-card-text class="mb-2">

                    </b-card-text>

                    <!-- form -->
                    <validation-observer ref="loginValidation">
                        <b-form
                                class="auth-login-form mt-2"
                                @submit.prevent
                        >
                            <!-- email -->
                            <b-form-group
                                    v-if="!show2FACode"
                                    label="E-mail"
                                    label-for="login-email"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="e-mail"
                                        rules="required"
                                >
                                    <b-form-input
                                            id="login-email"
                                            v-model="userEmail"
                                            :state="errors.length > 0 ? false:null"
                                            name="login-email"
                                            placeholder="john@example.com"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <!-- forgot password -->
                            <b-form-group
                                    v-if="!show2FACode"
                                    label="Jelszó"
                                    label-for="login-password">
                                <validation-provider
                                        #default="{ errors }"
                                        name="Jelszó"
                                        rules="required"
                                >
                                    <b-input-group
                                            class="input-group-merge"
                                            :class="errors.length > 0 ? 'is-invalid':null"
                                    >
                                        <b-form-input
                                                id="login-password"
                                                v-model="password"
                                                :state="errors.length > 0 ? false:null"
                                                class="form-control-merge"
                                                :type="passwordFieldType"
                                                name="login-password"
                                                placeholder="············"
                                        />
                                        <b-input-group-append is-text>
                                            <feather-icon
                                                    class="cursor-pointer"
                                                    :icon="passwordToggleIcon"
                                                    @click="togglePasswordVisibility"
                                            />
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <b-form-group
                                    v-if="show2FACode"
                                    label="Kétfaktoros hitelesítő kód (email)"
                                    label-for="2fa_code"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="2fa_code"
                                        rules="required"
                                >
                                    <b-form-input
                                            id="2fa_code"
                                            v-model="twoFaCode"
                                            :state="errors.length > 0 ? false:null"
                                            name="2fa_code"
                                            placeholder="ABCD1234"
                                    />
                                    <b-button
                                        variant="text"
                                        color="info"
                                        :disabled="resendLoading"
                                        @click="resend2FACode"
                                    >
                                        <feather-icon icon="RefreshCwIcon"></feather-icon>
                                        Kód újraküldése
                                    </b-button>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <b-form-group>
                                <VueTurnstile key="turnstile" id="turnstile" @verified="setCfToken" />
                            </b-form-group>

                            <!-- submit buttons -->
                            <b-button
                                    :loading="loading"
                                    :disabled="loading || !userEmail.length || !password.length || !cfToken.length || (show2FACode && !twoFaCode.length)"
                                    type="submit"
                                    variant="primary"
                                    block
                                    @click="onSubmit"
                            >
                                Belépés
                            </b-button>
                        </b-form>
                    </validation-observer>
                </b-col>
            </b-col>
            <!-- /Login-->
        </b-row>
    </div>
</template>

<script>
/* eslint-disable global-require */
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import DarkLogo from '@core/layouts/components/Logo.vue'
import LightLogo from '@core/layouts/components/LogoLight.vue'
import {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
} from 'bootstrap-vue'
import {required} from '@validations'
import {togglePasswordVisibility} from '@core/mixins/ui/forms'
import store from '@/store/index'
import VueTurnstile from "@/views/pages/_components/VueTurnstile.vue";

export default {
    components: {
        BRow,
        BCol,
        BLink,
        BFormGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroup,
        BFormCheckbox,
        BCardText,
        BCardTitle,
        BImg,
        BForm,
        BButton,
        DarkLogo,
        LightLogo,
        VueTurnstile,
        ValidationProvider,
        ValidationObserver,
    },
    mixins: [togglePasswordVisibility],
    data() {
        return {
            status: '',
            password: '',
            userEmail: '',
            cfToken: '',
            twoFaCode: '',
            cfSiteKey: '',
            show2FACode: false,
            loading: false,
            resendLoading: false,
            skin: this.$store.state.appConfig.layout.skin,
            sideImg: require('@/assets/images/pages/login-v2.svg'),
            logoImg: require('@/assets/images/logo/logo-light.svg'),
            // validation rulesimport store from '@/store/index'
            required,
        }
    },
    computed: {
        passwordToggleIcon() {
            return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
        },
        logoUrl() {
            if (store.state.appConfig.layout.skin === 'dark') {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.logoImg = require('@/assets/images/logo/logo-dark.svg')
                return this.logoImg
            }
            return this.logoImg
        },
        imgUrl() {
            if (store.state.appConfig.layout.skin === 'dark') {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
                return this.sideImg
            }
            return this.sideImg
        },
    },
    methods: {
        setCfToken(token) {
            this.cfToken = token;
        },
        resend2FACode() {
            this.resendLoading = true
            this.get2FACode()
        },
        onSubmit() {
            this.$refs.loginValidation.validate().then(success => {
                if (success) {
                    !this.show2FACode ? this.get2FACode() : this.login()
                }
            })
        },
        get2FACode() {
            this.$store.dispatch('get2FACode', {
                email: this.userEmail,
                password: this.password,
                "cf-turnstile-response": this.cfToken,
            }).then(response => {
                this.show2FACode = true

                if (process.env.NODE_ENV === 'development') {
                    this.twoFaCode = response.data.token.toString()
                }

                this.cfToken = response.data.validated_cf_token

                this.$helpers.showSuccessToast('A belépéshez szükséges kódot elküldtük az e-mail címére!')
            }).catch(error => {
                if (error.response.status && error.response.status === 422) {
                    this.$helpers.showWarningToast('Sikertelen belépés! Kérjük, ellenőrizze az adatokat!')
                } else {
                    this.$helpers.showErrorToast('Ismeretlen hiba! Kérjük, frissítse az oldalt és próbálja újra!')
                }
            }).finally(() => {
                this.loading = false
                this.resendLoading = false
            })
        },
        login() {
            this.$store.dispatch('login', {
                email: this.userEmail,
                password: this.password,
                "2fa_code": this.twoFaCode,
                "validated_cf_token": this.cfToken,
            }).then(() => {
                this.$store.dispatch('initCurrentUser').then(icResponse => {
                    const userData = icResponse.data
                    this.$ability.update(userData.ability)
                    this.$helpers.showSuccessToast('Sikeres belépés')
                    this.$router.push({name: 'home'})
                })
            }).catch(error => {
                if (error.response.data.validated_cf_token) {
                    this.cfToken = error.response.data.validated_cf_token
                }

                if (error.response.status && error.response.status === 422) {
                    this.$helpers.showWarningToast('Sikertelen belépés! Kérjük, ellenőrizze az adatokat!')
                } else {
                    this.$helpers.showErrorToast('Ismeretlen hiba! Kérjük, frissítse az oldalt és próbálja újra!')
                }
            }).finally(() => {
                this.loading = false
                this.resendLoading = false
            })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
